import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "social-broadcast-image-preview" */'./SocialBroadcastImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('social-broadcast-image-preview')),
  LoadingComponent: () => null
});